import {
  AbstractControl,
  UntypedFormControl,
  UntypedFormGroup,
  ValidatorFn,
  Validators,
} from "@angular/forms";
import { CreateAnnouncementModel } from "src/app/models/announcements/create-announcement-model";
import { Center } from "src/app/models/centers/center";
import { Profile } from "src/app/models/profiles/profile";

export class CreateAnnouncementForm {
  formGroup: UntypedFormGroup;
  users: Profile[];
  centers: Center[];

  constructor() {
    this.formGroup = new UntypedFormGroup({
      title: new UntypedFormControl(null, [
        Validators.required,
        ByteLengthValidator(54),
      ]),
      type: new UntypedFormControl(null, [Validators.required]),
      url: new UntypedFormControl(null),
      detail: new UntypedFormControl(null),
      remark: new UntypedFormControl(null),
      announceDate: new UntypedFormControl(null, [Validators.required]),
      expireDate: new UntypedFormControl(null, [Validators.required]),
      recipient: new UntypedFormControl(null),
    });
    this.users = [];
    this.centers = [];
  }

  public enableURL(): void {
    if (this.formGroup.controls["type"].value == "Text") {
      this.formGroup.controls["url"].setValidators([Validators.nullValidator]);
      this.formGroup.controls["url"].reset();
    } else {
      this.formGroup.controls["url"].setValidators([Validators.required]);
      this.formGroup.controls["url"].reset();
    }
  }

  public reset(): void {
    this.formGroup.reset();
    this.users = [];
    this.centers = [];
  }

  public getCreateAnnouncementModel(): CreateAnnouncementModel {
    return {
      Title: this.formGroup.controls["title"].value,
      Content: this.formGroup.controls["detail"].value,
      Url: this.formGroup.controls["url"].value,
      Type: this.formGroup.controls["type"].value,
      AnnounceDate: (
        this.formGroup.controls["announceDate"].value as Date
      ).toJSON(),
      ExpirationDate: (
        this.formGroup.controls["expireDate"].value as Date
      ).toJSON(),
      Remark: this.formGroup.controls["remark"].value,
      Users: this.users.map((user) => user.uuId),
      Centers: this.centers.map((center) => center.uuId),
    };
  }

  get invalidExpireDate(): boolean {
    return (
      (this.formGroup.controls["expireDate"].value as Date) <
      (this.formGroup.controls["announceDate"].value as Date)
    );
  }
}

function ByteLengthValidator(length: number): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    let encoder: TextEncoder = new TextEncoder();
    let valid = encoder.encode(control.value).length > length;
    return valid ? { byte: { value: control.value } } : null;
  };
}
